<!-- Solid in every state: with no schedule of its own the task is still due every working day, and a
     dashed edge would say "nothing here yet" about a real cadence. -->
<div class="schedule-card" [class.default]="!$isConfigured()" [class.configured]="$isConfigured()">

  <div class="schedule-card-head">
    <i class="schedule-card-icon fa-solid fa-calendar-days brand" aria-hidden="true"></i>

    <div class="schedule-card-summary">
      <span class="schedule-card-title">{{ $title() }}</span>
      @if ($subtitle()) {
        <span class="schedule-card-subtitle">{{ $subtitle() }}</span>
      }
    </div>

    @if (!$readonly()) {
      <wb-button class="schedule-card-launch" [size]="buttonSize" [displayStyle]="secondaryStyle" [label]="$isConfigured() ? 'Edit' : 'Set schedule'" [disabled]="!$canLaunchEditor()" [tooltip]="$canLaunchEditor() ? null : launcherTooltip" (onClick)="onLaunchEditor()" />
    }
  </div>

  <div class="schedule-card-next">
    <span class="schedule-card-row-label">Next</span>
    @if ($isPerVisit()) {
      <span class="schedule-card-more">Runs with each visit</span>
    } @else {
      <span class="schedule-card-dates">{{ $nextChips().join(' \u00b7 ') }}</span>
      @if ($moreCount() > 0) {
        <span class="schedule-card-more">+ {{ $moreCount() }} more this year</span>
      }
    }
  </div>

  <div class="schedule-card-exceptions">
    <div class="schedule-card-exceptions-head">
      <span class="schedule-card-row-label">Exceptions</span>

      @if (!$readonly()) {
        <div class="schedule-card-exception-actions">
          <button class="schedule-card-link" type="button" cdkOverlayOrigin #skipOrigin="cdkOverlayOrigin" (click)="onTogglePopover(ExceptionPopoverMode.Skip)">+ Skip</button>
          <!-- A hand-picked list already IS the extra dates. Offering the popover here would give one
               schedule two places to add a date, and they would disagree the moment either changed. -->
          @if (!$isDates()) {
            <button class="schedule-card-link" type="button" cdkOverlayOrigin #extraOrigin="cdkOverlayOrigin" (click)="onTogglePopover(ExceptionPopoverMode.Extra)">+ Extra date</button>

            <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="extraOrigin" [cdkConnectedOverlayPositions]="overlayPositions" [cdkConnectedOverlayOpen]="$openPopover() === ExceptionPopoverMode.Extra" [cdkConnectedOverlayHasBackdrop]="false" [cdkConnectedOverlayPush]="true" (overlayOutsideClick)="onClosePopover()" (detach)="onClosePopover()">
              <wb-schedule-exception-popover [mode]="ExceptionPopoverMode.Extra" [schedule]="$effectiveSchedule() ?? null" [exceptions]="$exceptions()" [context]="$context()" (changed)="onExceptionChange($event)" (cancelled)="onClosePopover()" />
            </ng-template>
          }
        </div>

        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="skipOrigin" [cdkConnectedOverlayPositions]="overlayPositions" [cdkConnectedOverlayOpen]="$openPopover() === ExceptionPopoverMode.Skip" [cdkConnectedOverlayHasBackdrop]="false" [cdkConnectedOverlayPush]="true" (overlayOutsideClick)="onClosePopover()" (detach)="onClosePopover()">
          <wb-schedule-exception-popover [mode]="ExceptionPopoverMode.Skip" [schedule]="$effectiveSchedule() ?? null" [exceptions]="$exceptions()" [context]="$context()" (changed)="onExceptionChange($event)" (cancelled)="onClosePopover()" />
        </ng-template>
      }
    </div>

    <wb-schedule-exceptions-list [rows]="$exceptionRows()" emptyText="No exceptions" (remove)="onRemoveException($event)" />
  </div>

</div>
